const items = [
    { text: "About", linkTo:"about" },
    { text: "Experience", linkTo:"work-experience" },
    { text: "Skills", linkTo:"skills" },
    { text: "Project", linkTo:"projects" },
    { text: "Contact", linkTo:"contact" },
]

export default items;